module.exports = __webpack_public_path__ + "img/img-serviceTwo.22d8c042.png";